<template>
    <div class="p-4">
        <div>
            <AppButton @click="selectAll()" type="button" element="button" size="sm">
                {{ $t('messages.select_all') }}
            </AppButton>
            <AppButton @click="deselectAll()" type="button" element="button" size="sm">
                {{ $t('messages.deselect_all') }}
            </AppButton>
            <div class="inline-block">({{ selectedStudents.length }})</div>
        </div>
        <div class="pt-3">
            <div class="block" v-for="student in students" :key="student.id">
                <label>
                    <input
                        type="checkbox"
                        :value="student.id"
                        name="students[]"
                        class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                        v-model="selectedStudents"
                    />
                    {{ student.full_name }}
                </label>
            </div>
        </div>
    </div>
</template>
<script>
import AppButton from '@/components/AppButton.vue';

export default {
    emits: ['update:modelValue'],

    components: {
        AppButton,
    },
    props: {
        students: {
            type: Array,
            required: true,
        },
        modelValue: {
            type: Array,
            required: false,
            default: () => [],
        },
    },
    data() {
        return {
            selectedStudents: this.modelValue,
        };
    },
    computed: {
        allSelected: function () {
            return this.selectedStudents.length === this.students.length;
        },
        noneSelected: function () {
            return this.selectedStudents.length === 0;
        },
    },
    methods: {
        deselectAll() {
            this.selectedStudents = [];
        },
        selectAll() {
            this.selectedStudents = this.students.map((x) => x.id);
        },
    },
    watch: {
        selectedStudents(newVal) {
            this.$emit('update:modelValue', newVal);
        },
        modelValue(newVal) {
            this.selectedStudents = newVal;
        },
    },
    mounted() {
        this.selectedStudents = this.modelValue;
    },
};
</script>
